import { API, api } from "@/lib/api";

export async function streamAsk(body, onEvent, retried = false) {
  const res = await fetch(`${API}/assistant/ask`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (res.status === 401 && !retried) {
    await api.post("/auth/refresh");
    return streamAsk(body, onEvent, true);
  }
  if (!res.ok) {
    let detail;
    try {
      detail = (await res.json()).detail;
    } catch {
      detail = null;
    }
    throw new Error(typeof detail === "string" ? detail : "Ask Lasso is unavailable right now. Please try again.");
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    let i;
    while ((i = buf.indexOf("\n\n")) >= 0) {
      const line = buf.slice(0, i);
      buf = buf.slice(i + 2);
      if (line.startsWith("data: ")) onEvent(JSON.parse(line.slice(6)));
    }
  }
}

export const withCitations = (text, sources = []) =>
  text.replace(/\[(\d+(?:\s*,\s*\d+)*)\]/g, (m, grp) =>
    grp
      .split(",")
      .map((n) => {
        const s = sources.find((x) => x.n === Number(n.trim()));
        return s ? `[\\[${n.trim()}\\]](${s.url})` : `[${n.trim()}]`;
      })
      .join("")
  );
